import ApiClient from '@afosto/api/ApiClient';

class Pricing {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add a pricing rule
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new pricing rule to the set
   * @returns {Promise}
   */
  createPricingRule(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/rules`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Evaluate the existing set of pricing rules
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Test to see if rules would be applied
   * @returns {Promise}
   */
  evaluateRules(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/rules/evaluate`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Get a of options for constraints
   *
   * @param {Object} options - The additional request options
   * @description Get a listing of available constraint rules
   * @returns {Promise}
   */
  getConstraintOptions(options = {}) {
    return this.apiClient.request({
      url: `/odr/options/rules/constraints`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a pricing rule
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a pricing rule
   * @returns {Promise}
   */
  getPricingRule(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/rules/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of pricing rules
   *
   * @param {Object} options - The additional request options
   * @description Get a listing of available pricing rules
   * @returns {Promise}
   */
  getPricingRules(options = {}) {
    return this.apiClient.request({
      url: `/odr/rules`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update a pricing rule
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update an existing pricing rule
   * @returns {Promise}
   */
  updatePricingRule(id, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/rules/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const pricing = new Pricing();

export default Pricing;
